import moment from 'moment';
import { getUserLanguage } from '@/modules/user/user.service';

export const DATE_FORMATS = Object.freeze({
  short: 'YYYY-MM-DD',
  DDMMYYYY: 'DD/MM/YYYY',
});

function isDate(dateObj) {
  return dateObj !== null ? moment(dateObj).isValid() : false;
}

function toDateObj(date) {
  return typeof dateObj !== 'string' ? date : parseToDate(date);
}

function isValidFormat(format) {
  return Object.values(DATE_FORMATS).includes(format);
}

function isValid(date, format) {
  return isDate(date) && isValidFormat(format);
}

export function now() {
  return moment();
}

export function parseToDate(dateString) {
  return isDate(dateString) ? moment(dateString).toDate() : null;
}

export function formatDate(date, format) {
  const localDate = toDateObj(date);
  return isValid(toDateObj(date), format) ? moment(localDate).format(format) : null;
}

export function formatToTimeAgo(date) {
  moment.locale(getUserLanguage());
  const localDate = toDateObj(date);
  return isDate(localDate) ? moment(localDate).fromNow() : null;
}
